// URL query parameter names
export const searchQueryParameterName = 's';
export const membershipTabParameterName = 'mbt';

// URL query parameter values
export const studentTabParameterValue = 'student';
export const daypassTabParameterValue = 'daypass';
